import { ChainId, ERC20Token } from '@pancakeswap/sdk'
import {
  bscTestnetTokens,
  bscTokens,
  ethereumTokens,
  goerliTestnetTokens,
  igraTokens,
  kasplexMainnetTokens,
  kasplexTokens,
} from '@pancakeswap/tokens'
import type { CommonPrice } from '../../src/fetchFarmsV3'

export const CAKE_BNB_LP_MAINNET = '0x0eD7e52944161450477ee417DE9Cd3a859b14fD0'

export type PriceHelper = {
  chain: string
  list: ERC20Token[]
}

export const CHAIN_ID_TO_CHAIN_NAME = {
  [ChainId.BSC]: 'bsc',
  [ChainId.ETHEREUM]: 'ethereum',
  [ChainId.GOERLI]: 'ethereum',
  [ChainId.BSC_TESTNET]: 'bsc',
  [ChainId.KASPLEX_MAINNET]: 'kasplexMainnet',
  [ChainId.KASPLEX_TESTNET]: 'kasplexTestnet',
  [ChainId.IGRA]: 'igra',
} satisfies Record<ChainId, string>

export const priceHelperTokens = {
  [ChainId.ETHEREUM]: {
    chain: 'ethereum',
    list: [ethereumTokens.weth, ethereumTokens.usdc, ethereumTokens.usdt],
  },
  [ChainId.BSC]: {
    chain: 'bsc',
    list: [bscTokens.wbnb, bscTokens.usdt, bscTokens.busd, bscTokens.eth],
  },
  [ChainId.KASPLEX_MAINNET]: {
    chain: 'kasplexMainnet',
    list: [
      kasplexMainnetTokens.wkas,
      kasplexMainnetTokens.zeal,
      kasplexMainnetTokens.nacho,
      kasplexMainnetTokens.kasper,
      kasplexMainnetTokens.usdc,
      kasplexMainnetTokens.usdt,
      kasplexMainnetTokens.wbnb,
      kasplexMainnetTokens.eth,
      kasplexMainnetTokens.yello,
    ],
  },
} satisfies Record<number, PriceHelper>

// for testing purposes
export const DEFAULT_COMMON_PRICE: Record<ChainId, CommonPrice> = {
  [ChainId.ETHEREUM]: {},
  [ChainId.GOERLI]: {
    [goerliTestnetTokens.mockA.address]: '10',
  },
  [ChainId.BSC]: {},
  [ChainId.IGRA]: {
    [igraTokens.usdt.address]: '1',
    [igraTokens.usdc.address]: '1',
  },
  [ChainId.KASPLEX_TESTNET]: {
    [kasplexTokens.usdt.address]: '1',
    [kasplexTokens.usdc.address]: '1',
  },
  [ChainId.KASPLEX_MAINNET]: {
    [kasplexMainnetTokens.usdt.address]: '1',
    [kasplexMainnetTokens.usdc.address]: '1',
  },
  [ChainId.BSC_TESTNET]: {
    [bscTestnetTokens.mockA.address]: '10',
    [bscTestnetTokens.usdt.address]: '1',
    [bscTestnetTokens.busd.address]: '1',
    [bscTestnetTokens.usdc.address]: '1',
  },
}
